import { remoteManifestUrl } from '@libs/focus-frontend-build/src/releaseManifest';
import type { ModuleFederationRuntimePlugin } from '@module-federation/runtime';

import { resolvedRelease } from './releaseResolution';

const releaseResolutionPlugin = (): ModuleFederationRuntimePlugin => ({
  name: 'release-resolution',
  async beforeRequest(args) {
    const release = await resolvedRelease();

    if (!release) {
      return args;
    }

    args.options.remotes.forEach((remote) => {
      const version = release.remotes[remote.name];

      if (version && 'entry' in remote) {
        remote.entry = remoteManifestUrl(remote.name, version);
      }
    });

    return args;
  },
});

export default releaseResolutionPlugin;
